export default {"src":"/_next/static/media/black_star.7f59875c.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};